const XENIA_PORTED_REQUEST_TYPES = new Set(["itinerary", "exploreCity", "activityDetails", "laresAlertChat"]);

export function isXeniaPortedRequestType(requestType: unknown): boolean {
  if (requestType == null || requestType === "") return true;
  return XENIA_PORTED_REQUEST_TYPES.has(requestType as string);
}
